/* Quick add on every product card: a round cart "+" button at the bottom right.
   One option: adds it and opens the cart drawer. Several options: opens the product page to choose. */
(function () {
  var CART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/><path d="M13 9.5v4"/><path d="M11 11.5h4"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var cache = {};

  var css = document.createElement('style');
  css.textContent = [
    '.card-wrapper.yqa-on > .card { position: relative; }',
    '.yqa-btn { position: absolute; right: 14px; bottom: 14px; z-index: 3; display: grid; place-items: center; width: 44px; height: 44px; padding: 0; border: 2px solid #1F1A1C; border-radius: 50%; background: #1F1A1C; color: #FFF9F6; box-shadow: 3px 3px 0 0 #F7B6C4; cursor: pointer; transition: transform .15s ease, box-shadow .15s ease, background .15s ease; }',
    '.yqa-btn svg { width: 21px; height: 21px; }',
    '.yqa-btn:hover { transform: translate(-1px, -1px); box-shadow: 4px 4px 0 0 #F7B6C4; }',
    '.yqa-btn:active { transform: translate(1px, 1px); box-shadow: 1px 1px 0 0 #F7B6C4; }',
    '.yqa-btn:focus-visible { outline: 2px solid #F7B6C4; outline-offset: 3px; }',
    '.yqa-btn.is-busy { opacity: .6; cursor: progress; }',
    '.yqa-btn.is-done { background: #257A52; border-color: #257A52; }',
    '.card-wrapper.yqa-on .card > .card__content .price { padding-right: 52px; }',
    '@media (max-width: 749px) { .yqa-btn { right: 10px; bottom: 10px; width: 38px; height: 38px; } .yqa-btn svg { width: 18px; height: 18px; } .card-wrapper.yqa-on .card > .card__content .price { padding-right: 44px; } }',
    '@media (prefers-reduced-motion: reduce) { .yqa-btn { transition: none; } }'
  ].join('\n');
  document.head.appendChild(css);

  function product(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    return cache[handle];
  }

  function add(btn, handle, url) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    product(handle).then(function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (!avail.length || (p.variants || []).length > 1) { location.href = url; return; }
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }], sections: sections, sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.innerHTML = CHECK;
        setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = CART; }, 1800);
        if (drawer && drawer.renderContents && res.sections) {
          drawer.classList.remove('is-empty');
          res.id = avail[0].id;
          drawer.renderContents(res);
        } else {
          location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      });
    }).catch(function () { location.href = url; }).then(function () { btn.classList.remove('is-busy'); });
  }

  function enhance(root) {
    (root || document).querySelectorAll('.card-wrapper[data-product-handle]:not(.yqa-on)').forEach(function (w) {
      var card = w.querySelector(':scope > .card'), link = w.querySelector('a[href*="/products/"]');
      if (!card || !link) return;
      w.classList.add('yqa-on');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'yqa-btn';
      var name = (link.textContent || '').trim();
      b.setAttribute('aria-label', 'Add ' + name + ' to cart'); b.title = 'Add to cart';
      b.innerHTML = CART;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); add(b, w.dataset.productHandle, link.href); });
      card.appendChild(b);
    });
  }

  function start() {
    enhance();
    new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { enhance(); break; } }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
